import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { services } from '../data/services';
import { processSteps } from '../data/site';
import { Icon } from '../utils/icons';
import { PageHero } from '../components/PageHero';
import { SectionHeading } from '../components/SectionHeading';
import { CtaBand } from '../components/CtaBand';
export function ServicesIndex() {
  return <>
      <PageHero eyebrow="What We Offer" title="Our Services" description="Cleaning and property support across Guernsey — for offices, rentals, holiday lets, new builds and everything in between." image={services[0].image} breadcrumb={[{
      label: 'Home',
      to: '/'
    }, {
      label: 'Services'
    }]} data-id="element-289" data-mp="3dcb9lvjt8jwt" />

      <section className="w-full bg-white" data-id="element-290" data-mp="2zjv0cd0bfpng">
        <div className="mx-auto max-w-7xl px-6 py-20 lg:py-24" data-id="element-291" data-mp="2zijw6c2ykfvt">
          <div className="grid gap-10 lg:grid-cols-2" data-id="element-292" data-mp="2ul0j3fhzy95g">
            {services.map((service, index) => <motion.article key={service.slug} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-80px'
          }} transition={{
            duration: 0.45,
            delay: index % 2 * 0.08
          }} className="flex flex-col border border-gray-200" data-id="element-293" data-mp="2ie2gde6z1mry" data-mpi={index}>
                <img src={service.image} alt={service.title} className="h-56 w-full object-cover" data-id="element-294" data-mp="1zgri9wx2sze3" />
                <div className="flex flex-1 flex-col p-8" data-id="element-295" data-mp="28go0pgsvh20p">
                  <span className="flex h-11 w-11 items-center justify-center bg-navy" data-id="element-296" data-mp="28f36xtedtn3w">
                    <Icon name={service.icon} className="h-5 w-5 text-gold" data-id="element-297" data-mp="2dh2ab3a4gk0u" />
                  </span>
                  <h2 className="mt-5 font-display text-xl font-extrabold uppercase tracking-wide text-navy" data-id="element-298" data-mp="3jvbd04t0vgkb">
                    {service.title}
                  </h2>
                  <p className="mt-3 text-[15px] leading-relaxed text-gray-600" data-id="element-299" data-mp="2z5h7bi16iaor">
                    {service.intro}
                  </p>
                  <ul className="mt-5 grid gap-2 sm:grid-cols-2" data-id="element-300" data-mp="2u9icpcp9bwfw">
                    {service.includes.slice(0, 4).map(item => <li key={item} className="flex items-start gap-2 text-[14px] text-gray-700" data-id="element-301" data-mp="345v76csmmebp">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-302" data-mp="2gdwoh7qulgoj" />
                        {item}
                      </li>)}
                  </ul>
                  <div className="mt-auto pt-7" data-id="element-303" data-mp="2ldj1ph6oewxc">
                    <Link to={`/services/${service.slug}`} className="inline-flex items-center gap-2 bg-gold px-7 py-3.5 font-display text-[12px] font-bold uppercase tracking-widest text-white transition-colors hover:bg-gold-dark" data-id="element-304" data-mp="1xp9lcus8f1dl">
                      Learn More
                      <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-305" data-mp="czw61zot18cn" />
                      <span className="sr-only" data-id="element-306" data-mp="3ugdoiav98tq8">about {service.title}</span>
                    </Link>
                  </div>
                </div>
              </motion.article>)}
          </div>
        </div>
      </section>

      <section className="w-full bg-gray-50" data-id="element-307" data-mp="qzf05oks6j5y">
        <div className="mx-auto max-w-7xl px-6 py-20 lg:py-24" data-id="element-308" data-mp="vxq97x394pn4">
          <SectionHeading eyebrow="How It Works" title="Simple From Start to Finish" data-id="element-309" data-mp="vvw0ri962pzx" />
          <ol className="mt-14 grid gap-8 sm:grid-cols-2 lg:grid-cols-4" data-id="element-310" data-mp="lzsohjklpaz9">
            {processSteps.map((step, index) => <li key={step.title} data-id="element-311" data-mp="32nwqgb8rsihr" data-mpi={index}>
                <span className="font-display text-4xl font-black text-gold/40" data-id="element-312" data-mp="32mv7lkliirph">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <h3 className="mt-3 font-display text-base font-extrabold uppercase tracking-wide text-navy" data-id="element-313" data-mp="3mxo9u6u7ou2y">
                  {step.title}
                </h3>
                <p className="mt-2 text-[15px] leading-relaxed text-gray-600" data-id="element-314" data-mp="3i4mphjb8k2bz">
                  {step.description}
                </p>
              </li>)}
          </ol>
        </div>
      </section>

      <CtaBand data-id="element-315" data-mp="9qmgelzcdf3z" />
    </>;
}